import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    user: {
      loggedIn: false,
      data: null
    },
    token: null,
  },
  getters: {
    user(state){
      return state.user
    },
    token(state){
      return state.token
    }
  },
  mutations: {
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER(state, data) {
      state.user.data = data;
    },
    SET_TOKEN(state, payload) {
      state.token = payload
    }
  },
  actions: {
    fetchUser({ commit }, user) {
      commit("SET_LOGGED_IN", user !== null);
      if (user) {
        var name = user.displayName;
        var welcomeName = name ? name : user.email;
        if (user.photoURL == null) {
          commit("SET_USER", {
            displayName: welcomeName,
            email: user.email,
            photoURL: "img/theme/engineering-24px.svg",
          });
        }
        else {
          commit("SET_USER", {
            displayName: welcomeName,
            email: user.email,
            photoURL: user.photoURL,
          });
        }
      } else {
        commit("SET_USER", null);
      }
    },
    fetchUserId({ commit }, token) {
      commit("SET_TOKEN", token);
    }
  }
});